import { useQuery } from '@tanstack/react-query';

import { fetchFunnel } from '@/api/v4/snapshot-funnel.api';
import { QueryKey } from '@/config/query-client';

import { companiesInProjectSelectedDateRangeTypeState } from '../companies-in-project.state';
import { parseDateRangeTypeToParams } from '../helpers/parse-date-range';
import { useAtomValue } from 'jotai';

export const useFunnelData = () => {
  const selectedDateRange = useAtomValue(
    companiesInProjectSelectedDateRangeTypeState,
  );

  const fetchFunnelData = async () => {
    const params = parseDateRangeTypeToParams(selectedDateRange);

    return fetchFunnel(params);
  };

  return useQuery({
    queryKey: [QueryKey.Funnel, selectedDateRange],
    queryFn: fetchFunnelData,
    staleTime: 1000 * 60 * 5,
  });
};
